module.exports = __webpack_public_path__ + "65517bf3ebbe0728ca39398fdc94a304.png";